import { useLang } from '../LangContext';

const sectionIds = ['home', 'about', 'programs', 'gallery', 'reviews', 'contact'];

const team = [
  { name: 'Mrs. Rashmi', role: 'Director', icon: '👩‍💼' },
  { name: 'Priya Shukla', role: 'Teacher', icon: '👩‍🏫' },
  { name: 'Khushi Shukla', role: 'Teacher', icon: '👩‍🏫' },
];

export default function Footer() {
  const { t, lang } = useLang();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Brand */}
        <div className="footer-brand">
          <div className="footer-logo">
            <img src="/gallery/logo.png" alt="Kids Play Hall Logo" className="logo-icon" style={{ height: '44px', width: '44px', objectFit: 'cover', borderRadius: '50%', border: '2.5px solid transparent', background: 'linear-gradient(#1a1a2e,#1a1a2e) padding-box, linear-gradient(135deg,#ff6b35,#ff4d8d,#7c3aed) border-box', padding: '2px' }} />
            <span className="logo-text">Kids Play Hall</span>
          </div>
          <p>{t.footerTagline}</p>
          <div className="footer-contact-mini">
            <div>📍 {t.footerAddress}</div>
            <div>📞 <a href="tel:+918127356940">+91 81273 56940</a></div>
            <div>🕐 {t.footerHours}</div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h4>{t.quickLinks}</h4>
          <ul>
            {sectionIds.map((id, i) => (
              <li key={id}>
                <button onClick={() => scrollTo(id)}>{t.footerLinks[i]}</button>
              </li>
            ))}
          </ul>
        </div>

        {/* Team */}
        <div className="footer-team">
          <h4>{lang === 'hi' ? 'हमारी टीम' : 'Our Team'}</h4>
          <div className="footer-team-list">
            {team.map((member) => (
              <div className="footer-team-card" key={member.name}>
                <span className="team-icon">{member.icon}</span>
                <div>
                  <div className="team-name">{member.name}</div>
                  <div className="team-role">
                    {lang === 'hi'
                      ? member.role === 'Director' ? 'निदेशक' : 'शिक्षिका'
                      : member.role}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Social */}
        <div className="footer-social">
          <h4>{t.followUs}</h4>
          <div className="social-icons">
            <a href="https://www.instagram.com/kidsplayhall.16125/" target="_blank" rel="noreferrer" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="ig-grad" x1="0%" y1="100%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#f09433"/>
                    <stop offset="25%" stopColor="#e6683c"/>
                    <stop offset="50%" stopColor="#dc2743"/>
                    <stop offset="75%" stopColor="#cc2366"/>
                    <stop offset="100%" stopColor="#bc1888"/>
                  </linearGradient>
                </defs>
                <rect width="24" height="24" rx="6" fill="url(#ig-grad)"/>
                <path d="M12 7.2A4.8 4.8 0 1 0 12 16.8 4.8 4.8 0 0 0 12 7.2zm0 7.92A3.12 3.12 0 1 1 12 8.88a3.12 3.12 0 0 1 0 6.24z" fill="white"/>
                <circle cx="17.04" cy="6.96" r="1.12" fill="white"/>
              </svg>
            </a>
            <a href="https://wa.me/918127356940" target="_blank" rel="noreferrer" aria-label="WhatsApp">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" rx="6" fill="#25D366"/>
                <path d="M12 4a8 8 0 0 0-6.93 11.97L4 20l4.17-1.06A8 8 0 1 0 12 4zm0 14.4a6.38 6.38 0 0 1-3.26-.9l-.23-.14-2.36.6.63-2.28-.15-.24A6.4 6.4 0 1 1 12 18.4zm3.51-4.77c-.19-.1-1.13-.56-1.31-.62-.17-.07-.3-.1-.42.1-.13.19-.48.62-.59.75-.11.12-.22.14-.41.05-.19-.1-.81-.3-1.54-.95-.57-.5-.95-1.13-1.06-1.32-.11-.19-.01-.29.08-.39.09-.09.19-.22.29-.34.1-.11.13-.19.19-.32.07-.12.03-.23-.01-.33-.05-.1-.43-1.03-.59-1.41-.15-.37-.31-.32-.42-.32h-.37c-.12 0-.33.04-.5.24-.18.19-.67.65-.67 1.58s.68 1.83.77 1.95c.1.13 1.33 2.03 3.21 2.84.45.19.8.31 1.07.4.45.14.86.12 1.18.07.36-.05 1.13-.46 1.29-.91.16-.44.16-.82.11-.91-.05-.07-.17-.12-.37-.22z" fill="white"/>
              </svg>
            </a>
            <a href="tel:+918127356940" aria-label="Call us">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" rx="6" fill="#ff6b35"/>
                <path d="M17.4 15.6c-.4-.4-1.8-1.2-2.2-1.2-.4 0-.6.2-1 .6-.3.4-.6.6-.9.6-.2 0-.6-.2-1.2-.6-.8-.6-1.5-1.3-2-2.1-.4-.6-.5-1-.5-1.2 0-.3.2-.6.6-.9.4-.4.6-.6.6-1 0-.4-.8-1.8-1.2-2.2-.3-.3-.6-.4-.9-.4-.7 0-2 1.3-2 2.4 0 .8.3 1.7 1 2.8.6 1 1.4 2 2.4 2.8 1 .9 2 1.6 3 2 1 .5 1.9.7 2.6.7 1.1 0 2.4-1.3 2.4-2 0-.3-.1-.6-.3-.8z" fill="white"/>
              </svg>
            </a>
            <a href="https://youtube.com/@kidsplayhall16125?si=gyzsvQPEdqG8IEHH" target="_blank" rel="noreferrer" aria-label="YouTube">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" rx="6" fill="#FF0000"/>
                <path d="M19.6 8.2a2 2 0 0 0-1.4-1.4C16.9 6.5 12 6.5 12 6.5s-4.9 0-6.2.3a2 2 0 0 0-1.4 1.4C4.1 9.5 4.1 12 4.1 12s0 2.5.3 3.8a2 2 0 0 0 1.4 1.4c1.3.3 6.2.3 6.2.3s4.9 0 6.2-.3a2 2 0 0 0 1.4-1.4c.3-1.3.3-3.8.3-3.8s0-2.5-.3-3.8z" fill="white"/>
                <path d="M10.5 14.5v-5l4.5 2.5-4.5 2.5z" fill="#FF0000"/>
              </svg>
            </a>
          </div>
          <div className="footer-cta">
            <p>🎉 {t.heroBadge1}</p>
            <button className="btn-primary" onClick={() => scrollTo('contact')}
              style={{ marginTop: '12px', padding: '11px 24px', fontSize: '0.9rem' }}>
              {t.navEnroll}
            </button>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>{t.footerBottom}</p>
      </div>
    </footer>
  );
}
